// @dopomogai/supabase-client/src/react/utils/validation.ts

/**
 * Checks if a value is provided (not empty).
 * @param value The value to check.
 * @returns An error message string or undefined.
 */
export const validateRequired = (value: string | undefined): string | undefined => {
    if (!value || value.trim() === '') {
      return 'This field is required.';
    }
    return undefined;
  };
  
  /**
   * Validates an email address format using a regular expression.
   * @param email The email string to validate.
   * @returns An error message string or undefined.
   */
  export const validateEmail = (email: string): string | undefined => {
    if (!email || email.trim() === '') {
      return 'Email is required.';
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return 'Please enter a valid email address.';
    }
    return undefined;
  };
  
  /**
   * Validates password strength based on length and character requirements.
   * @param password The password string to validate.
   * @returns An error message string or undefined.
   */
  export const validatePassword = (password: string): string | undefined => {
    if (!password) {
      return 'Password is required.';
    }
    if (password.length < 8) {
      return 'Password must be at least 8 characters long.';
    }
    if (!/\d/.test(password)) {
      return 'Password must contain at least one number.';
    }
    if (!/[a-zA-Z]/.test(password)) {
      return 'Password must contain at least one letter.';
    }
    return undefined;
  };
  
  /**
   * Checks if the password and confirmPassword fields match.
   * @param pass The password string.
   * @param confirmPass The confirmation password string.
   * @returns An error message string or undefined.
   */
  export const validatePasswordMatch = (pass: string, confirmPass: string): string | undefined => {
    if (pass !== confirmPass) {
      return 'Passwords do not match.';
    }
    return undefined;
  };